import React from "react";
import { ComoUsar } from "../../../../components";
import MeninaComLivroImg from "../../../../assets/images/consorcio/ilustracao-menina-segurando-livro.svg";

const AcionarSeguro = () => {
  return (
    <ComoUsar
      imgSrc={MeninaComLivroImg}
      imgAlt="Menina com livro"
      title="Quer acionar seu seguro?"
      description="Ligue para a Assistência Dia & Noite e Sinistros"
      telefone="0800 274 1000"
    />
  );
};

export default AcionarSeguro;
